type AppStatsFeature =
  | 'organigramme'
  | 'recherche'
  | 'sites'
  | 'tags'
  | 'notices'
  | 'admin'
  | 'profil'
  | 'autre'

type FeatureRule = {
  match: (name: string) => boolean
  feature: AppStatsFeature
}

function resolveAdminFeature(name: string): AppStatsFeature {
  if (name.includes('site')) return 'sites'
  if (name.includes('tag')) return 'tags'
  if (name.includes('notice') || name.includes('formation')) return 'notices'
  return 'admin'
}

function isOrganigrammeRoute(name: string): boolean {
  return (
    name === 'direction' ||
    name.startsWith('direction-') ||
    name.includes('orga') ||
    name.includes('equipe') ||
    name.includes('agence')
  )
}

const FEATURE_RULES: FeatureRule[] = [
  { match: (name) => name.includes('search'), feature: 'recherche' },
  { match: (name) => name.includes('site'), feature: 'sites' },
  { match: (name) => name.includes('tag'), feature: 'tags' },
  {
    match: (name) => name.includes('notice') || name.includes('charte') || name.includes('legal'),
    feature: 'notices',
  },
  {
    match: (name) => name.includes('profil') || name.includes('settings') || name.includes('avatar'),
    feature: 'profil',
  },
  { match: isOrganigrammeRoute, feature: 'organigramme' },
]

/**
 * Mappe un nom de route Nuxt vers une clé de fonctionnalité stats.
 */
export function resolveAppStatsFeature(routeName: string | null | undefined): AppStatsFeature {
  const name = (routeName ?? '').trim().toLowerCase()
  if (!name) {
    return 'autre'
  }
  if (name === 'admin' || name.startsWith('admin-')) {
    return resolveAdminFeature(name)
  }
  for (const rule of FEATURE_RULES) {
    if (rule.match(name)) {
      return rule.feature
    }
  }
  return 'autre'
}
